import React from 'react';
import { Bloc } from '@/scenes/Event/scenes/Candidate/scenes/Preparation/scenes/Onboarding/components/Bloc';
import { CardEvent, H3, Loader } from '@seekube-tech/ui-kit';
import { Col, Row } from 'antd';
import { find, flatten, flow, uniq, without, reduce } from 'lodash';
import FormItem from 'antd/lib/form/FormItem';
import { useFormatMessage } from 'react-intl-hooks';
import { useSelector } from 'react-redux';
import { getAuthUser } from '@/store/auth/selectors';
import { useInfiniteGetEvents } from '@/queries/events/useInfiniteGetEvents';
import {
  ShowMoreButton
} from '@/scenes/Event/scenes/Candidate/scenes/JobDating/scenes/Exponents/scenes/Exponent/components/ShowMoreButton';
import { Actions, Header, Infos } from '@/scenes/Auth/scenes/CandidateScenes/Discovery/components';

export const DiscoveryList = ({ form }) => {
  const t = useFormatMessage();
  const authUser = useSelector(getAuthUser)?.toJS()
  const eventsInfiniteQuery = useInfiniteGetEvents({});

  const selectedEvents = form.getFieldValue('eventIds') || [];

  const getSelectedTarget = (eventIds) => {

    const getEventsTargets = () => eventIds.map((selectedEventId) =>
      reduce(eventsInfiniteQuery?.data?.pages, (acc, page) =>
        find(page.docs, { _id: selectedEventId } )?.targets ?? acc, [])
    );


    return flow(getEventsTargets, flatten, uniq)();
  };

  const handleOnEventClick = (eventId) => {
    const eventIndex = selectedEvents.indexOf(eventId.toString());
    const eventIds = eventIndex === -1 ?
      [...selectedEvents, eventId.toString()]
      : without(selectedEvents, eventId);

    form.setFieldsValue({
      eventIds,
      trackersData: { targets: getSelectedTarget(eventIds), countTotalJD: eventsInfiniteQuery?.data?.total }
    });
  };

  return (
    <Bloc maxWidth="none">
      <div className="commonStep">
        <H3 className="mb-40">{t({ id: 'signup.discovery.title.b'})}</H3>
        <Row gutter={[25, 41]} className="gutter-row">

          {eventsInfiniteQuery.isLoading ? <div className="text-center my-20"><Loader /></div> :
            <FormItem>
              {form.getFieldDecorator('eventIds', {
                initialValue: [],
              })(
                <div>
                  {
                    eventsInfiniteQuery?.data?.pages?.map(page => page?.docs?.map((event) => (
                        <Col xs={12} sm={6} md={6} lg={4} key={event._id} className="leading-[15px]">
                          <div>
                            <CardEvent
                              picture={event.theme?.coverPictureUrl}
                              title={event.name}
                              variant="vertical"
                              actions={<Actions event={event} onClick={handleOnEventClick} selectedEvents={selectedEvents} />}
                              header={<Header event={event} />}
                              infos={<Infos event={event} authUser={authUser} />}
                              disabled={false}
                            />
                          </div>
                        </Col>
                      )
                    ))}
                </div>
              )}
            </FormItem>
          }
        </Row>

        <ShowMoreButton entityInfiniteQuery={eventsInfiniteQuery} />

        <FormItem className="hide">
          {form.getFieldDecorator('trackersData', {
            initialValue: { targets: [], countTotalJD: eventsInfiniteQuery?.data?.pages[0].total },
          })(
            <div />
          )}
        </FormItem>

      </div>
    </Bloc>
  )
}
